import { Flex, Text } from "@chakra-ui/react";
import { pad_with_zeroes } from "network/helper";
import { ProjectIdCellProps } from "../types";
import { CustomerTypeBadge } from "../../CustomerTypeBadge";

export function ProjectIdCell({ id, textColor, userId }: ProjectIdCellProps) {
  return (
    <Flex align="flex-start" direction="column" gap="2px">
      <Text
        color={id === "0012" ? "#F00" : textColor}
        fontSize="14px"
        lineHeight="24px"
        fontWeight="400"
        maxW={{ sm: "200px", md: "unset" }}
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        overflow="hidden"
      >
        {pad_with_zeroes(id, 6)}
      </Text>
      <CustomerTypeBadge userId={userId} />
    </Flex>
  );
}
